import { BRAND_NAME, PUBLIC_SITE_URL, BRAND_LOGO_PATH } from '@peles/shared';

export interface PublicPageFooterProps {
  /** Tints the wordmark to match the page it sits under. */
  accentColor?: string;
  className?: string;
}

/**
 * Sign-off for guest-facing public pages (invitations, seat finder,
 * questionnaires): the company logo and name, linking to the public site.
 *
 * Guests reaching these pages have often never heard of us — the footer is the
 * one place the invitation says who produced it, so it is a real link rather
 * than plain text.
 */
export function PublicPageFooter({ accentColor, className = '' }: PublicPageFooterProps) {
  return (
    <div className={`text-center ${className}`}>
      <a
        href={PUBLIC_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-xs text-gray-400 hover:text-gray-600 transition-colors"
        style={accentColor ? { color: accentColor } : undefined}
      >
        <img
          src={BRAND_LOGO_PATH}
          alt=""
          aria-hidden="true"
          className="h-5 w-auto object-contain"
        />
        <span>{BRAND_NAME}</span>
      </a>
    </div>
  );
}
